import {
  CSATData,
  CustomerSatisfactionBanner,
  FeedbackMediaType,
} from "@amzn/stencil-react-components/customer-satisfaction";
import { Text } from "@amzn/stencil-react-components/text";
import { trackUxmCustomEvent } from "common/helpers/analytics-helper";
import { getString } from "common/uistringlabels/uiStringUtils";
import React, { useMemo, useState } from "react";
import { FC } from "react";

const IMAGE_PATH = "/img/cfm-rocket.svg";

interface CustomerFeedbackBannerProps {
  touchpoint: string;
}

export const CustomerFeedbackBanner: FC<CustomerFeedbackBannerProps> = ({ touchpoint }) => {
  const [rating, setRating] = useState<number>(0);
  const [shouldShowFeedback, setShouldShowFeedback] = useState<boolean>(false);
  const [shouldShowOutroModal, setShouldShowOutroModal] = useState<boolean>(false);
  const mediaProps = useMemo(
    () => ({
      media: {
        altText: getString("customerFeedback.banner.imageAltText"),
        src: IMAGE_PATH,
        type: FeedbackMediaType.IMAGE,
      },
    }),
    []
  );

  const handleChange = (ratingIndex: number) => {
    setRating(ratingIndex);
    setShouldShowFeedback(true);
  };

  const handleHideFeedback = () => {
    setShouldShowFeedback(false);
    setShouldShowOutroModal(false);
  };

  const handleSubmit = (data: CSATData) => {
    setShouldShowFeedback(false);
    setShouldShowOutroModal(true);
    trackUxmCustomEvent(`cfm-banner-${touchpoint}`, {
      rating: (data.selectedRating ?? rating) + 1,
      comment: data.optionalData,
    });
  };

  const handleCancel = () => {
    setShouldShowFeedback(false);
    setShouldShowOutroModal(false);
    trackUxmCustomEvent(`cfm-banner-${touchpoint}`, {
      rating: rating + 1,
    });
  };

  return (
    <CustomerSatisfactionBanner
      CSATBannerOutroModalProps={{
        content: <Text>{getString("customerFeedback.banner.outro")}</Text>,
        onCancel: handleHideFeedback,
        onSubmit: handleHideFeedback,
        titleText: getString("customerFeedback.banner.outroTitle"),
      }}
      feedbackModalProps={{
        feedbackCardProps: {
          hasOptionalTextArea: true,
          optionalContentLabel: getString("customerFeedback.banner.feedbackLabel"),
        },
        onCancel: handleCancel,
        onSubmit: handleSubmit,
      }}
      mediaProps={mediaProps}
      ratingProps={{
        onChange: handleChange,
        options: getString("customerFeedback.banner.ratingOptions") as unknown as string[],
      }}
      subtitleText={getString("customerFeedback.banner.subtitleText")}
      titleText={getString("customerFeedback.banner.titleText")}
      shouldShowFeedbackModal={shouldShowFeedback}
      shouldShowOutroModal={shouldShowOutroModal}
    />
  );
};
